// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ipH2J","name":"Header_name__nhsGb","birthday":"Header_birthday__imxJN","skeleton":"Header_skeleton__sRAPI"};